<template>
  <v-container>
    <h3 class="mb-5">Edit Client</h3>
    <v-layout row>
      <v-flex xs4>
        <v-text-field
          v-model="client.clientCode"
          label="Client Code">
        </v-text-field>
      </v-flex>
      <v-flex xs6 ml-4>
        <v-text-field
          v-model="client.clientName"
          label="Name">
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs4>
        <v-text-field
          v-model="client.protocolType"
          label="Protocol Type">
        </v-text-field>
      </v-flex>
      <v-flex xs6 ml-4>
        <v-text-field
          v-model="client.clientUri"
          label="URI">
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs4>
        <v-text-field
          v-model="client.accessTokenLifetime"
          label="Access Token Lifetime (seconds)">
        </v-text-field>
      </v-flex>
      <v-flex xs6 ml-4>
        <v-text-field
          v-model="client.identityTokenLifetime"
          label="Identity Token Lifetime (seconds)">
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Grant Types
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <grant-types
                :grantTypes="client.clientGrantTypes">
              </grant-types>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Redirect
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <redirect-uris
                :clientRedirectUris="client.clientRedirectUris"
                :uriType="'Redirect'">
              </redirect-uris>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Post Logout Redirect
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <redirect-uris
                :clientRedirectUris="client.clientPostLogoutRedirectUris"
                :uriType="'Post Logout Redirect'">
              </redirect-uris>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RedirectUris from './RedirectUris'
import GrantTypes from './GrantTypes'

export default {
  components: {
    RedirectUris,
    GrantTypes
  },
  props: ['client'],
  methods: {
  }
}
</script>
